/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ message: NonNullable<unknown> }} Snapshot_History_Restore_ErrorInputs */

const en_snapshot_history_restore_error = /** @type {(inputs: Snapshot_History_Restore_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Unable to restore commit: ${i?.message}`)
};

const fr_snapshot_history_restore_error = /** @type {(inputs: Snapshot_History_Restore_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Unable to restore commit: ${i?.message}`)
};

const de_snapshot_history_restore_error = /** @type {(inputs: Snapshot_History_Restore_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Unable to restore commit: ${i?.message}`)
};

const it_snapshot_history_restore_error = /** @type {(inputs: Snapshot_History_Restore_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Unable to restore commit: ${i?.message}`)
};

const ru_snapshot_history_restore_error = /** @type {(inputs: Snapshot_History_Restore_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Unable to restore commit: ${i?.message}`)
};

const es_snapshot_history_restore_error = /** @type {(inputs: Snapshot_History_Restore_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Unable to restore commit: ${i?.message}`)
};

const zh_cn2_snapshot_history_restore_error = /** @type {(inputs: Snapshot_History_Restore_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Unable to restore commit: ${i?.message}`)
};

const ja_snapshot_history_restore_error = /** @type {(inputs: Snapshot_History_Restore_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Unable to restore commit: ${i?.message}`)
};

const hi_snapshot_history_restore_error = /** @type {(inputs: Snapshot_History_Restore_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Unable to restore commit: ${i?.message}`)
};

const pt_pt2_snapshot_history_restore_error = /** @type {(inputs: Snapshot_History_Restore_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Unable to restore commit: ${i?.message}`)
};

/**
* | output |
* | --- |
* | "Unable to restore commit: {message}" |
*
* @param {Snapshot_History_Restore_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const snapshot_history_restore_error = /** @type {((inputs: Snapshot_History_Restore_ErrorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Snapshot_History_Restore_ErrorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_snapshot_history_restore_error(inputs)
	if (locale === "de") return de_snapshot_history_restore_error(inputs)
	if (locale === "it") return it_snapshot_history_restore_error(inputs)
	if (locale === "ru") return ru_snapshot_history_restore_error(inputs)
	if (locale === "es") return es_snapshot_history_restore_error(inputs)
	if (locale === "zh-CN") return zh_cn2_snapshot_history_restore_error(inputs)
	if (locale === "ja") return ja_snapshot_history_restore_error(inputs)
	if (locale === "hi") return hi_snapshot_history_restore_error(inputs)
	if (locale === "pt-PT") return pt_pt2_snapshot_history_restore_error(inputs)
	return en_snapshot_history_restore_error(inputs)
});